export default __webpack_public_path__ + "static/media/pause.f70cb1d5.svg";